import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Media from 'react-media';
import Card from '../../../../../components/LazyWidgets/Card';
import StackedBar from '../../../../../components/LazyWidgets/StackedBar';
import s from './stackedBarReflection.module.css';
import { STACKEDBARS_COLORS } from '../../../reports-constants.js';

const StackedBarReflection = (props) => {
  const getNumberReflectionsByDraft = draft => Object.keys(STACKEDBARS_COLORS).reduce((previous, key) =>
    previous + draft[key],
    0
  );
  const draftsToDraw = props.drafts.filter(draft => getNumberReflectionsByDraft(draft) > 0);
  const legend = [
    {
      text: 'Strongly Disagree',
      color: STACKEDBARS_COLORS.stronglyDisagree,
    }, {
      text: 'Disagree',
      color: STACKEDBARS_COLORS.disagree,
    }, {
      text: 'Undecided / Neutral',
      color: STACKEDBARS_COLORS.neutral,
    }, {
      text: 'Agree',
      color: STACKEDBARS_COLORS.agree,
    }, {
      text: 'Strongly Agree',
      color: STACKEDBARS_COLORS.stronglyAgree,
    },
  ];
  const createBar = ((draft) => {
    const numberReflections = getNumberReflectionsByDraft(draft);
    return Object.keys(STACKEDBARS_COLORS).map(type =>
      ({ color: STACKEDBARS_COLORS[type], value: (draft[type] / numberReflections) * 100, zone: type })
    );
  });

  const data = {
    stackedBars: draftsToDraw.map(createBar),
    xLabels: {
      bottom: draftsToDraw.map(draft => moment(draft.dueDate).format('MMM Do')),
      top: draftsToDraw.map(draft => draft.name),
    },
    yLabels: [
      { text: '0%', value: 0, type: 'major' },
      { text: '10', value: 10 },
      { text: '20', value: 20 },
      { text: '30', value: 30 },
      { text: '40', value: 40 },
      { text: '50%', value: 50, type: 'major' },
      { text: '60', value: 60 },
      { text: '70', value: 70 },
      { text: '80', value: 80 },
      { text: '90', value: 90 },
      { text: '100%', value: 100, type: 'major' },
    ],
    legend,
    percentage: {
      active: false,
    },
  };
  let standardWidth;
  let mobileWidth;
  if (data.stackedBars.length > 6) {
    standardWidth = 146 * data.stackedBars.length;
  }
  if (data.stackedBars.length > 0) {
    mobileWidth = 120 * data.stackedBars.length;
  }
  return (
    <div>
      <Card className={s.containerCard}>
        <h2 className={s.titleStackedBars}>Responses over time</h2>
        <Media query="(min-width: 481px)">{
            matches => matches && <StackedBar data={data} minWidth={481} chartWidth={standardWidth} height={340} id="stackedBarReflection" className={s.stackedBars} />
        }</Media>
        <Media query="(min-width: 376px) and (max-width: 480px)">{
            matches => matches && <StackedBar data={data} minWidth={376} chartWidth={mobileWidth} height={218} id="stackedBarReflection" className={s.stackedBars} />
        }</Media>
        <Media query="(max-width: 375px)">{
            matches => matches && <StackedBar data={data} minWidth={200} chartWidth={mobileWidth} height={218} id="stackedBarReflection" className={s.stackedBars} />
        }</Media>
      </Card>
    </div>
  );
};

StackedBarReflection.propTypes = {
  drafts: PropTypes.arrayOf(PropTypes.object),
};
export default StackedBarReflection;
